function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVscode3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_vscode3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.821,4.321,24.023,2,11.493,14.212,3.833,8.385l-1.654.837V22.8l1.644.827,7.65-5.827L24.023,30l5.8-2.321V4.321ZM4.65,19.192V12.818L8.2,15.985,4.65,19.192ZM16,15.985l7.082-5.3V21.324l-7.092-5.339H16Z",
    style: {
      fill: "#007acc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode3);
export default __webpack_public_path__ + "static/media/vscode3.483ce3930fb0500d6d7dd42b4a64be47.svg";
export { ForwardRef as ReactComponent };